import { Box, Stack } from '@mui/material';
import { vars } from '@tgtg/kit';
import { Outlet } from 'react-router';

const LoginLayoutBase = () => {
  return (
    <Stack
      direction={'column'}
      sx={{
        minHeight: '100vh',
        height: '100dvh',
        maxHeight: '100dvh',
      }}
    >
      <Box
        sx={{
          backgroundColor: { sm: vars.color.surface.neutral },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flex: 1,
          padding: { xs: 0, sm: vars.spacing.neutral.gigantic },
        }}
      >
        <Stack
          direction='column'
          spacing={7}
          sx={{
            backgroundColor: vars.color.surface.background.base,
            borderRadius: { xs: 0, sm: vars.radius.xxlarge },
            px: { xs: vars.spacing.neutral.large, sm: vars.spacing.neutral.gigantic },
            py: vars.spacing.neutral.huge,
            maxWidth: '720px',
            width: '100%',
          }}
        >
          <Outlet />
        </Stack>
      </Box>
    </Stack>
  );
};

export default LoginLayoutBase;
